import { Container } from "unstated";
import { Buildup, BuildupTemplate } from "../generated/graphql";
import handleFilter from "../helpers/handleFilter";
import searchName from "../helpers/searchName";

interface IState {
  buildups: Buildup[];
  templates: BuildupTemplate[];
  needToCheck: boolean;
  needToCheckForChanges: boolean;
}

const initialState: IState = {
  buildups: [],
  needToCheck: true,
  needToCheckForChanges: true,
  templates: []
};

interface IFilter {
  id: string;
  parameter: string;
  operator: string;
  values: string[];
}

class OfflineData extends Container<IState> {
  public state = initialState;

  public setBuildups = (buildups: Buildup[]) => {
    this.setState({ buildups });
  };

  public setTemplates = (templates: BuildupTemplate[]) => {
    this.setState({ templates });
  };

  public setNeedToCheckForChanges = (needToCheckForChanges: boolean) => {
    this.setState({ needToCheckForChanges });
  };

  public checkLocalStorage = () => {
    const buildups = localStorage.getItem("buildups");
    const templates = localStorage.getItem("templates");

    if (!this.state.needToCheck) {
      return;
    }
    if (buildups && templates) {
      this.setState({
        buildups: JSON.parse(buildups),
        needToCheck: false,
        templates: JSON.parse(templates)
      });
      return;
    }
    this.setState({ needToCheck: false });
  };

  public searchBuildups = (filters: IFilter[], searchTerm: string) => {
    return this.state.buildups.filter(b => {
      return searchName(b.name, searchTerm, "or") && searchFilters(b, filters);
    });
  };
}

const searchFilters = (buildup: any, filters: IFilter[]) => {
  const checkFilters = filters
    .map(filter => {
      const { parameter, values, operator } = filter;
      if (values.length === 0 || !operator || !parameter) {
        return true;
      }
      if (values.length === 1) {
        const value = values[0];
        if (value.trim() === "") {
          return true;
        }
        return handleFilter(parameter, operator, value, buildup);
      }
      if (values.length === 2) {
        const v1 = parseFloat(values[0]);
        const v2 = parseFloat(values[1]);
        if (isNaN(v1) || isNaN(v2)) {
          return {};
        }
        const orderCheck = v1 < v2;
        switch (operator) {
          case "between": {
            if (orderCheck) {
              return buildup[parameter] >= v1 && buildup[parameter] <= v2;
            }
            return buildup[parameter] >= v2 && buildup[parameter] <= v1;
          }
          case "notBetween": {
            if (orderCheck) {
              return buildup[parameter] < v1 || buildup[parameter] > v2;
            }
            return buildup[parameter] < v2 || buildup[parameter] > v1;
          }
          default:
            return false;
        }
      }
      return false;
    })
    .find(check => check === false);
  if (checkFilters === undefined) {
    return true;
  }
  return false;
};

export default OfflineData;
